import stakeholderRepository from '@/repositories/stakeholder.repository'

class StakeholderService {
  async modifiedStakeholderUnsubscribe (stakeholderId) {
    const data = await stakeholderRepository.modifiedStakeholderUnsubscribe(stakeholderId);
    return data || [];
  }
  async checkStakeholderInfo (answererDto) {
    const data = await stakeholderRepository.checkStakeholderInfo(answererDto);
    return data || [];
  }
  async findAllActiveInfo () {
    const data = await stakeholderRepository.findAllActiveInfo();
    return data || [];
  }
  async findActiveStakeholder (currentPage, pageSize) {
    const data = await stakeholderRepository.findActiveStakeholder(currentPage, pageSize);
    return data || [];
  }
  async saveStakeholderInfo (updateStakeholderInfo, isAdd) {
    const data = await stakeholderRepository.saveStakeholderInfo(updateStakeholderInfo, isAdd);
    return data || [];
  }
  async findStakeholderInfoByConditions (stakeholderSearchInfo) {
    const data = await stakeholderRepository.findStakeholderInfoByConditions(stakeholderSearchInfo);
    return data || [];
  }
  async findSearchConditions (activeType) {
    const data = await stakeholderRepository.findSearchConditions(activeType);
    return data || [];
  }
}
module.exports = new StakeholderService();



// WEBPACK FOOTER //
// ./src/services/stakeholder.service.js